import {
    BudgetSections,
    BudgetExpenseOrIncome,
    GESTIONNAIRE_FIELD,
    BudgetRealOrOrder,
    BudgetPhases,
} from 'business/constants';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import {
    ANALYTIC_FIELD,
    REAL_ORDER_FIELD,
    ANTENNA_FIELD,
    ANTENNA_NAME_FIELD,
    LINE_CODE_FIELD,
    BUDGET_LINE_ID,
    BUDGET_NAME_FIELD,
    BUDGET_YEAR_FIELD,
    CHAPTER_FIELD,
    CHAPTER_LABEL_FIELD,
    ENRICHED_OPERATION_ID,
    EXPENSE_INCOME_FIELD,
    FUNCTION_FIELD,
    FUNCTION_LABEL_FIELD,
    GESTIONNAIRE_SOFTWARE_ID,
    INSCRIPTION_EXERCICE,
    INSCRIPTION_EXPENSE_INCOME,
    INSCRIPTION_ID,
    INSCRIPTION_INVESTMENT_OPERATING,
    NATURE_FIELD,
    NATURE_LABEL_FIELD,
    OPERATION_FIELD,
    OPERATION_NAME_FIELD,
    OPERATION_SOFTWARE_ID,
    ORG_CHART_FINANCE_FIELD,
    ORG_CHART_FINANCE_SOFTWARE_ID,
    PROJECT_ID,
    SECTION_FIELD,
    ORG_CHART_FINANCE_CODE_FIELD,
    BUDGET_LINE_CODE,
    ANALYTIC_NAME_FIELD,
    BUDGET_CODE_FIELD,
    GESTIONNAIRE_CODE_FIELD,
    ANALYTIC_POST_1_CODE,
    ANALYTIC_POST_2_CODE,
    ANALYTIC_POST_3_CODE,
    ANALYTIC_POST_4_CODE,
    INSCRIPTION_ORIGINAL_COMMENT,
    INSCRIPTION_ORIGINAL_AMOUNT,
    VOTED_TOTAL_FIELD,
    REQUESTED_FIELD,
    ORG_CHART_FINANCE_NAME_FIELD,
    LINE_NAME_FIELD,
    IN_WRITE_SCOPE,
    IS_PHASE_EDITABLE,
    IS_PHASE_MOVABLE,
    IS_EDITION_OPEN_TO_RESOURCE,
    CAN_MOVE,
    CAN_EDIT,
    BUDGET_PROPOSAL_PHASE,
    ANALYTIC_POST_1_NAME,
    ANALYTIC_POST_2_NAME,
    ANALYTIC_POST_3_NAME,
    ANALYTIC_POST_4_NAME,
    AP_CODE,
    AP_START_YEAR,
    OPERATION_SEGMENT_CODE,
    STRAT_FOCUS_CODE,
    SUPER_OPERATION_FIELD,
    DIRECTION_CODE,
    DIRECTION_LABEL,
    SUB_NATURE_FIELD,
    SUB_NATURE_LABEL_FIELD,
    BUDGET_LINE_PROGRAM_NAME,
    ENVELOPPE_LABEL,
    ENVELOPPE_CODE,
    BUDGET_LINE_PROGRAM_CODE,
    ANALYTIC_NATURE_NAME,
    ANALYTIC_NATURE_CODE,
    CHAPTER_SOFTWARE_ID,
    NATURE_SOFTWARE_ID,
    SECONDARY_BUDGET_AXIS_ELEMENT_SOFTWARE_ID,
    SUB_FUNCTION_FIELD,
    SUB_FUNCTION_LABEL_FIELD,
    SUPER_OPERATION_NAME_FIELD,
    IS_REJECTED,
    PHASE_AMOUNT,
    PHASE_STATUS,
    PHASE_COMMENT,
    PHASE_ID,
    SECONDARY_BUDGET_AXIS_ELEMENT_NAME_FIELD,
    SECONDARY_BUDGET_AXIS_ELEMENT_CODE,
    ENVELOPPE_SOFTWARE_ID,
    BUDGET_LINE_OPERATION_VENTILATION_CODE,
    BUDGET_LINE_ENVELOPPE_VENTILATION_CODE,
} from 'routes/BudgetModule/config/constants';
import { getResourceSoftwareIdField } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { RQAPICallWithData } from 'store/APIClient';
import { getMatchingBudgetProposal } from './budgetProposal';
import { BUDGET_LINE_SOFTWARE_ID } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/constants';

export type CommentsPerInscription = {
    [inscriptionId: number]: [nbComment: number];
};

export type PhaseInscriptionT = {
    phase: string;
    id: number;
    [PHASE_STATUS]: string;
    [PHASE_AMOUNT]: number;
    [PHASE_COMMENT]?: string;
};

export type InscriptionT = {
    inscription?: number;
    id?: number;
    [INSCRIPTION_ID]: number;
    [BUDGET_NAME_FIELD]: string;
    [SECTION_FIELD]: BudgetSections;
    [EXPENSE_INCOME_FIELD]: BudgetExpenseOrIncome;
    [BUDGET_PROPOSAL_PHASE]: string;
    [BUDGET_YEAR_FIELD]: number;
    [BUDGET_LINE_ID]?: number;
    [BUDGET_LINE_SOFTWARE_ID]?: string;
    [VOTED_TOTAL_FIELD]?: number;
    [REQUESTED_FIELD]?: number;
    [GESTIONNAIRE_SOFTWARE_ID]?: string;
    [ORG_CHART_FINANCE_FIELD]?: string;
    [ORG_CHART_FINANCE_SOFTWARE_ID]?: string;
    [ORG_CHART_FINANCE_NAME_FIELD]?: string;
    [GESTIONNAIRE_FIELD]?: string;
    [GESTIONNAIRE_CODE_FIELD]?: string;
    [CHAPTER_FIELD]?: string;
    [CHAPTER_LABEL_FIELD]: string;
    [CHAPTER_SOFTWARE_ID]?: string;
    [NATURE_FIELD]?: string;
    [FUNCTION_FIELD]?: string;
    [SUB_FUNCTION_FIELD]?: string;
    [ANTENNA_FIELD]?: string;
    [OPERATION_FIELD]?: string;
    [PROJECT_ID]: number[];
    [OPERATION_NAME_FIELD]?: string;
    [OPERATION_SOFTWARE_ID]?: string;
    [SUPER_OPERATION_NAME_FIELD]?: string;
    [ENRICHED_OPERATION_ID]?: number;
    [INSCRIPTION_EXPENSE_INCOME]?: string;
    [INSCRIPTION_EXERCICE]: number;
    [INSCRIPTION_INVESTMENT_OPERATING]?: string;
    [NATURE_LABEL_FIELD]?: string;
    [NATURE_SOFTWARE_ID]?: string;
    [FUNCTION_LABEL_FIELD]?: string;
    [SUB_FUNCTION_LABEL_FIELD]?: string;
    [ANTENNA_NAME_FIELD]?: string;
    [LINE_CODE_FIELD]?: string;
    [LINE_NAME_FIELD]?: string;
    [ANALYTIC_FIELD]?: string;
    [BUDGET_LINE_CODE]?: string;
    [ANALYTIC_NAME_FIELD]?: string;
    [BUDGET_CODE_FIELD]: string;
    [BUDGET_LINE_PROGRAM_NAME]?: string;
    [BUDGET_LINE_PROGRAM_CODE]?: string;
    [ENVELOPPE_LABEL]?: string;
    [ENVELOPPE_CODE]?: string;
    [ENVELOPPE_SOFTWARE_ID]?: string;
    [BUDGET_LINE_OPERATION_VENTILATION_CODE]?: string;
    [BUDGET_LINE_ENVELOPPE_VENTILATION_CODE]?: string;
    [ORG_CHART_FINANCE_CODE_FIELD]: string;
    [REAL_ORDER_FIELD]: BudgetRealOrOrder;
    [ANALYTIC_POST_1_CODE]?: string;
    [ANALYTIC_POST_1_NAME]?: string;
    [ANALYTIC_POST_2_CODE]?: string;
    [ANALYTIC_POST_2_NAME]?: string;
    [ANALYTIC_POST_3_CODE]?: string;
    [ANALYTIC_POST_3_NAME]?: string;
    [ANALYTIC_POST_4_CODE]?: string;
    [ANALYTIC_POST_4_NAME]?: string;
    [AP_CODE]?: string;
    [AP_START_YEAR]?: string;
    [OPERATION_SEGMENT_CODE]?: string;
    [SECONDARY_BUDGET_AXIS_ELEMENT_SOFTWARE_ID]?: string;
    [SECONDARY_BUDGET_AXIS_ELEMENT_NAME_FIELD]?: string;
    [SECONDARY_BUDGET_AXIS_ELEMENT_CODE]?: string;
    [STRAT_FOCUS_CODE]?: string;
    [SUPER_OPERATION_FIELD]?: string;
    [DIRECTION_LABEL]?: string;
    [DIRECTION_CODE]?: string;
    [SUB_NATURE_FIELD]?: string;
    [SUB_NATURE_LABEL_FIELD]?: string;
    [INSCRIPTION_ORIGINAL_AMOUNT]?: number;
    [INSCRIPTION_ORIGINAL_COMMENT]?: string;
    [ANALYTIC_NATURE_NAME]?: string;
    [ANALYTIC_NATURE_CODE]?: string;
    [IN_WRITE_SCOPE]: boolean;
    [IS_PHASE_EDITABLE]: boolean;
    [IS_PHASE_MOVABLE]: boolean;
    [IS_EDITION_OPEN_TO_RESOURCE]: boolean;
    [IS_REJECTED]: boolean;
    [CAN_MOVE]: boolean;
    [CAN_EDIT]: boolean;
    [PHASE_STATUS]: string;
    [PHASE_AMOUNT]: number;
    [PHASE_COMMENT]?: string;
    [PHASE_ID]?: number;
    ['phases']: PhaseInscriptionT[];
};
export type InscriptionStatusFields = Extract<
    keyof InscriptionT,
    typeof PHASE_STATUS
>;

const INSCRIPTION_GENERIC_PHASE_FIELDS = [
    'amount',
    'status',
    'comment',
    'id',
] as const;
export type InscriptionGenericPhaseTableFieldT =
    (typeof INSCRIPTION_GENERIC_PHASE_FIELDS)[number];

export const isGenericPhaseField = (
    key: unknown,
): key is InscriptionGenericPhaseTableFieldT => {
    if (typeof key === 'string') {
        return INSCRIPTION_GENERIC_PHASE_FIELDS.includes(key);
    }
    return false;
};

export const getFieldValueFromPhase = (
    phase: BudgetPhases,
    field: keyof PhaseInscriptionT,
    data: InscriptionT,
): string | number | undefined => {
    const phaseData = data['phases']?.find((p) => p.phase === phase);
    if (!phaseData) {
        return undefined;
    }
    return phaseData[field] ?? '';
};

export const getAmountFromPhase = (
    phase: BudgetPhases,
    data: InscriptionT,
): number | undefined => {
    return getFieldValueFromPhase(phase, 'amount', data) as number | undefined;
};

export type InscriptionGenericPhaseFieldT = InscriptionGenericPhaseTableFieldT;

export type PhaseFieldValueT = string | number | undefined | number[] | boolean;

const patchGetDataValueSection = (section?: string | null): string | null => {
    if (
        section === 'unknown' ||
        section === null ||
        section === undefined ||
        section === ''
    ) {
        return null;
    }
    return section.toLocaleString();
};

export const getBudgetProposalFromInscription = (
    inscription: InscriptionT,
    budgetProposals: BudgetProposalT[],
): BudgetProposalT => {
    const patchedInscriptionSection = patchGetDataValueSection(
        inscription[INSCRIPTION_INVESTMENT_OPERATING],
    );
    const budgetProposalKey = {
        budgetName: inscription[BUDGET_NAME_FIELD],
        section: patchedInscriptionSection,
        exercice: inscription[INSCRIPTION_EXERCICE],
    };
    return getMatchingBudgetProposal(budgetProposalKey, budgetProposals, true)!;
};

/**
 * Extracts "parent" resource software_id from inscription.
 * For now, we still base this on ventilation
 */
export const getResourceSoftwareIdFromInscription = (
    inscription: InscriptionT,
    budgetProposal: BudgetProposalT,
): string | undefined => {
    const resourceSoftwareIdField = getResourceSoftwareIdField(
        budgetProposal.by,
    );
    return inscription[resourceSoftwareIdField];
};

export const isOrphan = (inscription: InscriptionT): boolean =>
    !inscription[BUDGET_LINE_ID];

// a Wandering inscription is an inscription that has no resource (service/gestionnaire),
// a wandering can be linked to a budget line or not, so it can be wandering as well as wandering AND orphan
export const isWandering = (
    inscription: InscriptionT,
    budgetProposals: BudgetProposalT[],
): boolean => {
    const bp = getBudgetProposalFromInscription(inscription, budgetProposals);
    return !inscription[bp.by];
};

type InscriptionPatchResponseT = {
    ['enriched_operation.software_id']?: string;
    ['operation.code']: number;
    ['operation.name']: string;
    ['operation.software_id']: string;
    ['antenna.name']?: string;
    ['budget_line.id']?: number;
    ['chapter.code']?: number;
    ['chapter.label']?: string;
    ['function.label']?: string;
    ['function.number']?: number;
    ['gestionnaire.name']?: string;
    ['nature.label']?: string;
    ['nature.number']?: number;
    ['org_chart_finance.code']?: string;
    ['org_chart_finance.name']?: string;
    ['org_chart_finance.tree']?: string;
};

export const inscriptionUpdateApiCall = async ({
    id,
    data: body,
}: {
    id: number;
    data: {
        'operation.softwareId'?: string;
        'draftOperation.softwareId'?: string;
        'budgetLine.id'?: number;
        'chapter.softwareId'?: string;
        'nature.softwareId'?: string;
    };
}): Promise<{
    content: {
        message: string;
        data: InscriptionPatchResponseT;
    };
}> => {
    const response = await RQAPICallWithData<InscriptionPatchResponseT>({
        endpoint: `inscriptions/${id}`,
        body,
        method: 'PATCH',
    });
    return response;
};
